'use client';
import { useMediaQuery } from '@react-hookz/web';
import { useParams } from 'next/navigation';

import { usePaywallContext } from '~context/paywall';
import { CheckoutReason } from '~features/annals';

import { promoEventConfig } from '../../config';
import { useIsMembershipPromoEventActive } from '../../hooks/useIsMembershipPromoEventActive';
import { useIsPromoEventActive } from '../../hooks/useIsPromoEventActive';
import { ClickableArea, Container, PromoEventImage } from './styles';

export const PromoEventButton = () => {
	const promoEventActive = useIsPromoEventActive();

	const { openPaywall } = usePaywallContext();
	const { recipientId = '' } = useParams<{ recipientId?: string }>();
	const isDialogPage = !!recipientId;
	const isMobile = useMediaQuery('screen and (max-width: 768px)');

	const { active: offersSpecialMembership, isLoading } =
		useIsMembershipPromoEventActive();

	const image = offersSpecialMembership
		? promoEventConfig.offersSpecialMembership.imagePath
		: promoEventConfig.imagePath;
	const imageAlt = offersSpecialMembership
		? promoEventConfig.offersSpecialMembership.imageAlt
		: promoEventConfig.imageAlt;
	const onClick = offersSpecialMembership
		? openPaywall({
				checkoutReason: CheckoutReason.PromoEvent,
				prefer: 'subscription',
				defaultPromocode: promoEventConfig.offersSpecialMembership.promoCode,
		  })
		: openPaywall({
				checkoutReason: CheckoutReason.PromoEvent,
				prefer: 'neurons',
				defaultPromocode: promoEventConfig.promoCode,
		  });

	if (!promoEventActive || isLoading) {
		return null;
	}

	// According to the buisness requirements, only special membership button should be visible on mobile on dialog page
	if (isMobile && isDialogPage && !offersSpecialMembership) {
		return null;
	}

	// According to the buisness requirements, special membership button on dialogs page should have unique offset
	const hasSpecialMembershipDialogMobileLayout =
		offersSpecialMembership && isMobile;

	return (
		<Container
			bottomOffset={hasSpecialMembershipDialogMobileLayout ? 'auto' : undefined}
		>
			<PromoEventImage src={image} width={200} height={200} alt={imageAlt} />
			<ClickableArea onClick={onClick} />
		</Container>
	);
};
